import { LengthValidatorConfig, ValdrValidator } from '@app/valdr/models';
import { stringLengthValidator } from '@app/valdr/validators/length-validator';
import * as R from 'ramda';

export const minLengthValidator: ValdrValidator = R.curry(({number: minLength}: LengthValidatorConfig, value: any) =>
  stringLengthValidator(R.lte(minLength), value)
);
